export default "__VITE_ASSET__itwf45VM__"